import { GetApiActionWithAuthorization } from "constantFunctions/apiActions";
import { PostApiWithAuthorizationAction } from "constantFunctions/apiActions";
import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { FormGroup, Input, Table, Button, Tooltip } from "reactstrap";
import ConfirmationDeleteModal from "views/Modal/ConfirmationDeleteModal";
import { InfoCircle } from 'tabler-icons-react';
import { enableFileItemUploader } from "../../../libs/common";

function ViewOnlyItems(props) {
  const [confirm, setConfirm] = useState(false);
  const [delId, setDelId] = useState("");
  const [tooltipOpen, setTooltipOpen] = useState(false);

  useEffect(() => {
    setTimeout(() => {
      for(let saveItem of props.items.items) {
        enableFileItemUploader("[id^='fileuploader-" + saveItem.id + "']", props.isBarter);
        window.jQuery("[id^='fileuploader-" + saveItem.id + "']").show();
      }
    }, 100);
  }, []);

  const toggleConfirm = (id = "") => {
    setDelId(id);
    setConfirm(!confirm);
  };

  const addTicketSold = (buyerId, soldDescription, soldAmount) => {
    const soldToBuyers = props.soldBuyers.filter(buyer => buyer.description && buyer.description.length > 0)
    PostApiWithAuthorizationAction(
      "coin-tickets/add-ticket-sold/" + props.match.params.id,
      {
        buyerId,
        soldDescription,
        soldAmount: soldAmount || 0,
        soldToBuyers: soldToBuyers.map(buyer => buyer.name),
        soldTotalAmount: soldToBuyers.reduce((total, buyer) => total + (buyer.soldToAmount || 0), 0)
      }
    )
      .then((res) => {
        // toast.success(res.message, { position: toast.POSITION.TOP_CENTER });
      })
      .catch((err) => {
        if (err.status === 403) {
          props.setUnauthorized(true);
        } else if (err.status === 440) {
          props.resetState();
          toast.error(err.message, { position: toast.POSITION.TOP_CENTER });
          props.history.push("/auth/login");
        }
      });
  };

  const soldTicketItems = (index) => {
    /*if (!props.soldBuyers[index].soldToAmount || props.soldBuyers[index].soldToAmount <= 0) {
      toast.error("Sold to amount must be greater than 0", { position: toast.POSITION.TOP_CENTER });
      return;
    }*/
    // find all soldBuyers name
    let soldBuyersNames = props.soldBuyers.map(buyer => buyer.name);
    const soldItems = props.items.items.filter(item => item.soldTo !== "" && !soldBuyersNames.includes(item.soldTo));
    if (soldItems.length === 0) return;
    const soldItemsDescriptions = soldItems.map(item => item.item.name.replace(/.\s\(Weight:[\s\S]*?\)/g, ''));
    let soldBuyerDescription = props.soldBuyers[index].description|| "";
    props.soldBuyers[index].description = (soldBuyerDescription.length > 0 ? soldBuyerDescription + "\n" : "") + soldItemsDescriptions.join("\n");
    // update soldTo on evey soldItems then update props.items.items
    soldItems.forEach(item => {
      item.soldTo = props.soldBuyers[index].name;
    });
    props.items.items = props.items.items.map(item => {
      const soldItem = soldItems.find(sold => sold.id === item.id);
      return soldItem ? soldItem : item;
    });
    // addticketsold
    addTicketSold(props.soldBuyers[index].id, props.soldBuyers[index].description || "", props.soldBuyers[index].soldToAmount)
    //
    updateTicketItemSoldTo(props.soldBuyers[index].name, soldItems.map(item => item.id));
    props.setSoldBuyers([...props.soldBuyers]);
  };

  const cancelSoldTo = (itemId) => {
    const index = props.items.items.findIndex(item => item.id === itemId);
    // find the item in props.items.items
    const item = props.items.items.find(item => item.id === itemId);
    if (!item) return;
    // find the soldBuyer
    const soldBuyer = props.soldBuyers.find(buyer => buyer.name === item.soldTo);
    if (!soldBuyer) return;
    // remove the item from soldBuyer description
    const itemDescription = item.item.name.replace(/.\s\(Weight:[\s\S]*?\)/g, '');
    soldBuyer.description = soldBuyer.description.split('\n').filter(line => line !== itemDescription).join('\n');
    // update soldTo on the item
    item.soldTo = "";
    props.items.items = props.items.items.map(i => i.id === item.id ? item : i);
    // update backend
    updateTicketItemSoldTo("", [item.id]);
    props.setSoldBuyers([...props.soldBuyers]);
    addTicketSold(soldBuyer.id, soldBuyer.description || "", soldBuyer.soldToAmount)
  };
  const toggle = () => setTooltipOpen(!tooltipOpen);
  //----- After delete modal confirm successfully -------
  const confirmed = (e) => {
    GetApiActionWithAuthorization(
      "coin-tickets/delete-item-from-ticket/" +
        delId +
        "/" +
        props.match.params.id
    )
      .then((res) => {
        props.fetchCoinItemsListingSuccess({
          data: res.data,
          ticketDetails: res.ticketDetails,
        });
        //toast.success(res.message, { position: toast.POSITION.TOP_CENTER });
        setConfirm(false);
      })
      .catch((err) => {
        if (err.status === 403) {
          props.setUnauthorized(true);
        } else if (err.status === 440) {
          props.resetState();
          toast.error(err.message, { position: toast.POSITION.TOP_CENTER });
          props.history.push("/auth/login");
        }
      });
  };

  const renderSoldBuyerTable = () => {
    let soldBuyersNames = props.soldBuyers.map(buyer => buyer.name);
    const soldToSet = props.items.items.filter(item => soldBuyersNames.includes(item.soldTo));
    return props.soldBuyers.map((soldBuyer, i) => {
      return (
            <tr
              key={i}
              id={"row-" + soldBuyer.id}>
              <td style={{width: '50px', borderLeft: 'none'}}>
                <Button
                  size="xs"
                  className="print-go-back"
                  color="primary"
                  disabled={soldToSet.length > 0 && soldToSet.length === props.items.items.length}
                  onClick={(e) => {
                    soldTicketItems(i);
                  }}
                >Sell</Button>
              </td>
              <td style={{width: '60px', verticalAlign: 'middle'}}>{soldBuyer.name}</td>
              <td style={{width: '600px'}}>
                <Input
                  id={"item-description-" + i}
                  type="textarea"
                  placeholder="Description"
                  value={soldBuyer.description}
                  rows={1}
                  style={{fieldSizing: 'content'}}
                  onBlur={(e) => {
                    addTicketSold(soldBuyer.id, e.target.value, soldBuyer.soldToAmount)
                  }}
                  onChange={(e) => props.changeBuyerValues("description", e.target.value, i)}
                />
              </td>
              <td style={{width: '180px'}}>
                <Input
                  id={"soldToAmount"+i}
                  type="number"
                  defaultValue={soldBuyer.soldToAmount}
                  style={{width: soldBuyer.autoCalculateSpotPrice ? '80%' : '100%', display: 'inline'}}
                  placeholder="Amount"
                  onBlur={(e) => {
                    addTicketSold(soldBuyer.id, soldBuyer.description, e.target.value)
                  }}
                  onChange={(e) => props.changeBuyerValues("soldToAmount", e.target.value, i)}
                  onKeyPress={(event) => {
                    if (!/[0-9]/.test(event.key)) {
                      event.preventDefault();
                    }
                  }}
                />
                {
                  (soldBuyer.autoCalculateSpotPrice ? 
                    <>
                      <InfoCircle
                        size="12"
                        style={{width: '1.5rem', marginLeft: '0.5rem'}}
                        id={'tooltip-' + soldBuyer.id}/>
                      <Tooltip
                        placement="right"
                        isOpen={tooltipOpen}
                        target={'tooltip-' + soldBuyer.id}
                        toggle={toggle}
                      >
                        {props.spotPrices.map((spotPrice) => {
                          return(<div key={spotPrice.id}>{spotPrice.item}: {spotPrice.price}</div>);
                        })}
                      </Tooltip>
                    </> : null)
                }
              </td>
            </tr>
    )})
  }

    /*const changeBuyerValues = (name, value, index) => {
      let temp = props.soldBuyers;
      let itemObj = temp[index];
      itemObj[name] = value;
      temp[index] = itemObj;
      console.log(value);
      props.setSoldBuyers(temp);
    };*/

  const changeItemValues = (name, value, index) => {
    let temp = props.items.items;
    let itemObj = temp[index];
    itemObj[name] = value;
    temp[index] = itemObj;
    props.fetchCoinItemsListingSuccess({
      data: temp,
      ticketDetails: props.items.ticketDetails
    });
  };

  const updateTicketItemSoldTo = (name, id) => {
    let body = {
      ticketId: props.match.params.id,
      itemId: id,
      soldTo: name,
    };
    PostApiWithAuthorizationAction("coin-tickets/edit-items-send-items", body)
      .then((res) => {
        props.fetchCoinItemsListingSuccess({
          data: res.data,
          ticketDetails: res.ticketDetails,
        });
      })
      .catch((err) => {
        if (err.status === 403) {
          props.setUnauthorized(true);
        } else if (err.status === 440) {
          props.resetState();
          toast.error(err.message, { position: toast.POSITION.TOP_CENTER });
          props.history.push("/auth/login");
        }
      });
  };

  //-------- Sold to check box handler of items-----------------
  const checkBoxChangeHandler = (e, name, id) => {
    const { checked } = e.target;
    let body = {
      ticketId: props.match.params.id,
      itemId: id,
    };
    if (checked) {
      body.soldTo = name;
    } else {
      body.soldTo = "";
    }

    PostApiWithAuthorizationAction("coin-tickets/edit-items-send-items", body)
      .then((res) => {
        props.fetchCoinItemsListingSuccess({
          data: res.data,
          ticketDetails: res.ticketDetails,
        });
      })
      .catch((err) => {
        if (err.status === 403) {
          props.setUnauthorized(true);
        } else if (err.status === 440) {
          props.resetState();
          toast.error(err.message, { position: toast.POSITION.TOP_CENTER });
          props.history.push("/auth/login");
        }
      });
  };

  const selectAllOfSoldTo = (value) => {
    let body = {
      ticketId: props.match.params.id,
      selectAllOnly: true,
      soldTo: value,
    };
    PostApiWithAuthorizationAction("coin-tickets/edit-items-send-items", body)
      .then((res) => {
        props.fetchCoinItemsListingSuccess({
          data: res.data,
          ticketDetails: res.ticketDetails,
        });
      })
      .catch((err) => {
        if (err.status === 403) {
          props.setUnauthorized(true);
        } else if (err.status === 440) {
          props.resetState();
          toast.error(err.message, { position: toast.POSITION.TOP_CENTER });
          props.history.push("/auth/login");
        }
      });
  };

  const deleteItem = () => {
    let appendQuery = (props.isBarter) ? "barter=true" : "";
    if (appendQuery.length > 0) {
      appendQuery = "?" + appendQuery;
    }
    GetApiActionWithAuthorization(
      "coin-tickets/delete-item-from-ticket/" + delId + "/" + props.match.params.id + appendQuery
    )
      .then((res) => {
        if (props.isBarter) {
          props.fetchCoinBarterItemsListingSuccess({ data: res.data });
        } else {
          props.fetchCoinItemsListingSuccess({ data: res.data });
        }
        //
        setConfirm(false);
      })
      .catch((err) => {
        if (err.status === 440) {
          toast.error(err.message, { position: toast.POSITION.TOP_CENTER });
          props.history.push("/auth/login");
        } else {
          toast.error("Something went wrong! /n Please clear and retry", {
            position: toast.POSITION.TOP_CENTER,
          });
        }
      });
  };

const getSearchableContent = (description)=>{
    return description.split(". ")[1]
    ? description.split(". ")[1].trim()
    : "";
 
}

  return (
    <>
      <Table className="coin-items-listing mb-5" bordered responsive="sm">
        <thead>
          <tr>
            <th style={{ width: "90px" }}><i class="fas fa-camera"></i></th>
            <th style={{ width: "60px" }}> QTY</th>
            <th style={{ minWidth: "300px" }}>Item Description</th>
            <th style={{ width: "80px" }}>Unit</th>
            <th style={{ width: "80px" }}>Total</th>
            <th
              style={{ width: "60px" }}
              className="pointer"
              onClick={(e) => selectAllOfSoldTo("A")}
            >
              Sold&nbsp;to
            </th>
            {/*<th
              style={{ width: "60px" }}
              className="pointer"
              onClick={(e) => selectAllOfSoldTo("B")}
            >
              Sold to B
            </th>*/}
            {/* <th style={{ width: "50px" }}>Edit</th> */}
            <th style={{ width: "60px" }}>Delete</th>
          </tr>
        </thead>
        <tbody>
          {props.items.items.map((item, i) => {
            const soldBuyersNames = props.soldBuyers.map(buyer => buyer.name);
            if (props.search) {
              if (getSearchableContent(item.description).includes(props.search.trim())) {
                return (
                  <tr key={i} style={{background: props.highlightId == item.id ? '#eee' : '#fff'}} id={"row-" + item.id}>
                    <td colSpan={1} style={{ paddingLeft: "10px" }}>
                      <input
                        type="file"
                        name="files[]"
                        id={"fileuploader-" + item.id}
                        style={{ display: "none" }}
                        data-fileuploader-files={JSON.stringify(item.pictureUrl ? [{
                          name: item.pictureUrl.split('/').pop(),
                          type: item.pictureMimeType,
                          size: item.pictureSize,
                          file: item.pictureUrl,
                          local: item.pictureUrl,
                          data: {
                            url: item.pictureUrl,
                            thumbnail: item.picture300Url,
                            readerForce: true
                          }
                        }] : [])}/>
                    </td>
                    <td>{item.qty}</td>
                    <td style={{ whiteSpace: "normal" }}>
                    {item.item.name}
                    </td>
                    <td>${item.unit}</td>
                    <td>${item.cost}</td>
                    <td>
                      <input
                        type="checkbox"
                        name="a"
                        checked={item.soldTo.toLowerCase() !== ""}
                        onChange={(e) => changeItemValues("soldTo", e.target.checked ? "a" : "", i)}
                        disabled={soldBuyersNames.includes(item.soldTo)}
                      />
                    </td>
                    {/*<td>
                      <input
                        type="checkbox"
                        name="b"
                        checked={item.soldTo.toLowerCase() === "b"}
                        onChange={(e) => checkBoxChangeHandler(e, "B", item.id)}
                      />
                    </td>*/}
                    <td>
                      <a href="#" onClick={(e) => toggleConfirm(item.id)}>
                        Delete
                      </a>
                    </td>
                  </tr>
                );
              } else {
                return null;
              }
            } else {
              return (
                <tr key={i} style={{background: props.highlightId == item.id ? '#eee' : '#fff'}} id={"row-" + item.id}>
                  <td colSpan={1} style={{ paddingLeft: "10px" }}>
                    <input
                      type="file"
                      name="files[]"
                      id={"fileuploader-" + item.id}
                      style={{ display: "none" }}
                      data-fileuploader-files={JSON.stringify(item.pictureUrl ? [{
                        name: item.pictureUrl.split('/').pop(),
                        type: item.pictureMimeType,
                        size: item.pictureSize,
                        file: item.pictureUrl,
                        local: item.pictureUrl,
                        data: {
                          url: item.pictureUrl,
                          thumbnail: item.picture300Url,
                          readerForce: true
                        }
                      }] : [])}/>
                  </td>
                  <td>{item.qty}</td>
                  <td style={{ whiteSpace: "normal" }}>
                  {item.item.name}
                  </td>
                  <td>${item.unit}</td>
                  <td>${item.cost}</td>
                  <td>
                    <div className="">
                      <input
                        type="checkbox"
                        name="a"
                        checked={item.soldTo.toLowerCase() !== ""}
                        onChange={(e) => changeItemValues("soldTo", e.target.checked ? "a" : "", i)}
                        disabled={soldBuyersNames.includes(item.soldTo)}
                      />
                    </div>
                    <div className="">
                      {soldBuyersNames.includes(item.soldTo) && (
                        <a
                          href="#"
                          onClick={(e) => cancelSoldTo(item.id)}>
                          Cancel
                        </a>
                      )}
                    </div>
                  </td>
                  {/*<td>
                    <input
                      type="checkbox"
                      name="b"
                      checked={item.soldTo.toLowerCase() === "b"}
                      onChange={(e) => checkBoxChangeHandler(e, "B", item.id)}
                    />
                  </td>*/}
                  <td>
                    <a href="#" onClick={(e) => toggleConfirm(item.id)}>
                      Delete
                    </a>
                  </td>
                </tr>
              );
            }
          })}
        </tbody>
      </Table>
      <table
        className="check-table table-bordered"
        bordered
        responsive="sm"
        style={{margin: 'auto', marginTop: '-49px'}}>
        <tbody>
          { renderSoldBuyerTable() }
        </tbody>
      </table>
      {confirm && (
        <ConfirmationDeleteModal
          show={confirm}
          toggle={toggleConfirm}
          confirmed={deleteItem}
        />
      )}
    </>
  );
}

export default ViewOnlyItems;
